import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { Http } from '@capacitor/http';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';

// Detección robusta de nativo (múltiples señales)
const isLikelyNative = (() => {
  try {
    if (Capacitor?.isNativePlatform?.()) return true;
    if (typeof window !== 'undefined') {
      if (window.webkit?.messageHandlers?.bridge) return true;
      if (/^(capacitor|file|ionic):/.test(window.location.protocol)) return true;
    }
  } catch (_) {}
  return false;
})();

let getToken = () => null;
let onUnauthorized = () => {};

export function configureApi({ tokenProvider, unauthorizedHandler }) {
  getToken = tokenProvider;
  onUnauthorized = unauthorizedHandler || (() => {});
}

const tokenHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const wrap = (promise) =>
  promise
    .then((r) => ({ data: r.data ?? r }))
    .catch((err) => {
      const status = err?.response?.status ?? err?.status ?? 0;
      const data = err?.response?.data ?? err?.data ?? err?.message ?? 'Error';
      if (status === 401) onUnauthorized();
      const e = new Error(typeof data === 'string' ? data : 'Request failed');
      e.response = { status, data };
      throw e;
    });

const makeNative = () => ({
  get: (url, cfg = {}) =>
    wrap(Http.request({
      url: `${API_BASE}${url}`,
      method: 'GET',
      headers: { ...tokenHeader(), ...(cfg.headers || {}) },
      connectTimeout: 5_000,
      readTimeout: (cfg.timeout || 30_000) / 1_000,
    })),
  post: (url, body, cfg = {}) =>
    wrap(Http.request({
      url: `${API_BASE}${url}`,
      method: 'POST',
      data: body,
      headers: { 'Content-Type': 'application/json', ...tokenHeader(), ...(cfg.headers || {}) },
      connectTimeout: 5_000,
      readTimeout: (cfg.timeout || 30_000) / 1_000,
    })),
  put: (url, body, cfg = {}) =>
    wrap(Http.request({
      url: `${API_BASE}${url}`,
      method: 'PUT',
      data: body,
      headers: { 'Content-Type': 'application/json', ...tokenHeader(), ...(cfg.headers || {}) },
      connectTimeout: 5_000,
      readTimeout: (cfg.timeout || 30_000) / 1_000,
    })),
  delete: (url, cfg = {}) =>
    wrap(Http.request({
      url: `${API_BASE}${url}`,
      method: 'DELETE',
      headers: { ...tokenHeader(), ...(cfg.headers || {}) },
      connectTimeout: 5_000,
      readTimeout: (cfg.timeout || 30_000) / 1_000,
    })),
});

const webHttp = axios.create({
  baseURL: API_BASE,
  timeout: 30_000,
});

webHttp.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

webHttp.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) onUnauthorized();
    return Promise.reject(err);
  },
);

export const api = isLikelyNative ? makeNative() : webHttp;
export default api;